import { useState } from "react";

export const useTncCheckbox = () => {
  const [isChecked, setIsChecked] = useState(false);
  return { isChecked, setIsChecked };
};
